module.exports = __webpack_public_path__ + "img/water-rat-feeding.a3430397e6207e3a7f2156924cf0541a.jpg";